import * as XLSX from '@e965/xlsx';
import type { Role, PopulatedUser } from '../types';

function formatDate(dateStr: string | undefined): string {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toLocaleDateString('en-CA');
  } catch {
    return '';
  }
}

function getCreatorName(createdBy: string | PopulatedUser | undefined): string {
  if (!createdBy) return '';
  if (typeof createdBy === 'string') return createdBy;
  if (typeof createdBy === 'object' && '_id' in createdBy) {
    const name = [createdBy.firstname, createdBy.lastname].filter(Boolean).join(' ');
    return name || createdBy.email || createdBy._id;
  }
  return '';
}

function formatPermissionCount(role: Role): string {
  const allow = role.permissions.filter((p) => p.v === 'allow').length;
  const deny = role.permissions.filter((p) => p.v === 'deny').length;
  const parts: string[] = [];
  if (allow > 0) parts.push(`${allow} allow`);
  if (deny > 0) parts.push(`${deny} deny`);
  return parts.join(', ') || '0';
}

export function exportRolesToExcel(roles: Role[], filename?: string): void {
  const headers = ['Role ID', 'Permissions', 'Created By', 'Created At'];

  const rows = roles.map((r) => [
    r.roleId || '',
    formatPermissionCount(r),
    getCreatorName(r.created_by),
    formatDate(r.created_at),
  ]);

  const data = [headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(data);

  ws['!cols'] = [
    { wch: 25 }, // Role ID
    { wch: 18 }, // Permissions
    { wch: 20 }, // Created By
    { wch: 12 }, // Created At
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Roles');

  const exportFilename = filename || `roles_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(wb, exportFilename);
}
